import self from "../img/self.jpg";
import mock1 from "../img/mock1.png";
import mock2 from "../img/mock2.png";
import mock3 from "../img/mock3.png";
import mock4 from "../img/mock4.png";
import mock5 from "../img/mock5.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
  firstName: "Lucas",
  lastName: "Lopez",
  initials: " L.L", // the example uses first and last, but feel free to use three or more if you like.
  position: "React Developer",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: "☕",
      text: "Amor por el Café",
    },
    {
      emoji: "🌎",
      text: "Actualmente vivo en Argentina - Tucumán",
    },
    {
      emoji: "💼",
      text: "React Developer en Softtek y Tutor JavaScript & ReactJS en CoderHouse",
    },
    {
      emoji: "📧",
      text: "lukaz1802.LL@gmail.com",
    },
  ],
  socials: [
    {
      link: "https://api.whatsapp.com/send/?phone=5493816046088",
      icon: "fa fa-whatsapp",
      label: "whatsapp",
    },
    {
      link: "https://github.com/Lukaz1802",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://www.linkedin.com/in/lucas-lopez-8bb151210/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "",
      icon: " ",
      label: "",
    },
    {
      link: "",
      icon: " ",
      label: "",
    },

    // Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: "Hola, soy Lucas Lopez. Programador Web FullStack especializado en el FrontEnd con ReactJS. Actualmente trabajo como React Developer en Softtek y me encuentro dictando cursos de JavaScript y ReactJS como Tutor en CoderHouse.",
  skills: {
    proficientWith: [
      "JavaScript",
      "JSON",
      "React",
      "Custom React Hooks",
      "NextJS",
      "Git",
      "API Request",
      "Github",
      "Bootstrap",
      "MaterialUI",
      "explo-cli/react-native",
      "NodeJS",
      "MongoDB",
      "HTML5",
      "Css3",
    ],
    exposedTo: ["MySQL", "PHP", "TypeScript", "Linux"],
  },
  hobbies: [
    {
      label: "videojuegos",
      emoji: "🎮",
    },

    {
      label: "peliculas",
      emoji: "🎥",
    },
    {
      label: "superheroes",
      emoji: "🦸",
    },

    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    {
      title: `Cripto Price. Proyecto creado con ReactJS y NextUI para los estilos útilizando la API de Binance. En mi repositorio tambien encontraras una versión útilizando el WebSocket de Binance para ver el precio actualizandose en tiempo real :)`,
      live: "https://cripto-price-react-js.vercel.app/", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      source: "https://github.com/Lukaz1802/Cripto-price-ReactJS", // this should be a link to the **repository** of the project, where the code is hosted.
      image: mock1,
    },

    {
      title:
        "MovieDB. Proyecto creado en ReactJS útilizando la API de themoviedb",
      live: "https://proyecto-pagina-web-cine.vercel.app/",
      source: "https://github.com/Lukaz1802/Proyecto-PaginaWebCine.github.io",
      image: mock2,
    },
    {
      title:
        "E-Commerce de Café. Creado con NextJS usando la mayoria de los hooks de ReactJS..",
      live: "https://e-commerce-de-cafe.vercel.app/",
      source: "https://github.com/Lukaz1802/e-commerce-de-cafe",
      image: mock5,
    },
    {
      title:
        "CRUD ReactJS. Crud creado para practicar UseContext y AppReducer. :)",
      live: "https://crud-use-context.vercel.app/",
      source: "https://github.com/paytonjewell",
      image: mock4,
    },
    {
      title:
        "ComicBook Store. Uno de mis proyectos que hice cuando estaba recien aprendiendo HTML, Css y Javascript.",
      live: "https://comicbookstorelucaslopez.netlify.app/",
      source: "https://github.com/Lukaz1802/Biblioteca-proyecto-solitario",
      image: mock3,
    },
  ],
};
